<template>
  <div>
    <div class="postavitev-info-vsebine">
      <div class="info-okvir">
        <div class="postavitev-info-icone">
          <i class="fa fa-info-circle"></i>
        </div>
        <div class="postavitev-info-tekst">
          <p class="modra-barva-info">
            <b>
              Vsi računi so plačani. Hvala! =)
            </b>
          </p>
        </div>
      </div>
      <div style="clear: both"/>
    </div>
  </div>
</template>

<script>
import {povezave} from '../../../../../assets/js/Povezave/povezave'

export default {
  name: 'InfoKomponentaRacuni',
  data () {
    return {
      stranRazlagaRacunaUrl: ''
    }
  },
  mounted () {
    this.stranRazlagaRacunaUrl = povezave.BASE_URL_RAZLAGA_RACUNA
  }
}
</script>

<style scoped>
.info-okvir {
  width: 310px;
  display: flex;
}

.postavitev-info-vsebine {
  padding-top: 20px;
  float: right;
}

.postavitev-info-tekst {
  padding-top: 8px;
}

@media only screen and (max-width: 1500px) {
  .postavitev-info-vsebine {
    float: none;
    padding-top: 30px;
    padding-bottom: 30px;
  }
}

@media screen and (min-width: 550px) and (max-width: 600px) {
  .info-okvir {
    width: 100%;
    height: 100%;
  }
}

.warning-mobile-only {
  display: none;
}

@media screen and (max-width: 550px) {
  .warning-mobile-only {
    display: block;
  }

  .info-okvir {
    width: 100%;
  }

    .postavitev-info-tekst {
    padding-top: 3px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/MojT2/Racuni/InfoKomponentaRacuni.vue